<!--
 * @Author: zyb
 * @Date: 2022-03-29 11:37:47
 * @LastEditors: wyj
 * @LastEditTime: 2022-05-09 11:13:20
 * @FilePath: \dev_2.0\src\views\home\childComp\HomeSwiper\HomeSwiper.vue
 * @Description: 
-->
<template>
  <div class="home-swiper">
    <div class="" :class="screenWidth > 765 ? 'swiper-pc' : 'swiper-mb'">
      <swiper :options="swiperOption" ref="homeSwiper"  @click-slide="goPage">
        <swiper-slide v-for="(item, index) in swiperList" :key="index">
          <img :src="item.pic"  class="item-img" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
  props: ["swiperList", "screenWidth"],
  data() {
    return {
      swiperOption: {
        loop: true,
        initialSlide: 0,
        //自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false,
        },
        //滑动速度
        speed: 300,
        //滑动方向
        direction: "horizontal",
        //小手掌抓取滑动
        grabCursor: true,
        //分页器设置
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets",
        },
      },
    };
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  methods: {
    goPage(index,realIndex) {
      const item = this.swiperList[realIndex]
      if (item.path) {
        this.$store.dispatch("saveTabInStore", {});
        location.href = item.path;
        // location.href = 'http://192.168.100.150:8080/zh/productInfo?id=b3578e2be76f19ec34f9aa9f723cbd7a&name=S3系列'
      }
    },
  },
};
</script>
<style lang="scss">
@import "./sass/mb.scss";
@import "./sass/pc.scss";
.home-swiper {
  background-color: #eeeeee;
  .swiper-container {
    width: 100%;
  }
  .swiper-pagination-fraction,
  .swiper-pagination-custom,
  .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 38rem / $rem;
    left: 0;
    right: 0;
  }
  .swiper-pagination-bullet {
    width: 40rem / $rem;
    height: 4px;
    border-radius: 0;
    background-color: #dcdcdc;
  }
  .swiper-pagination-bullet-active {
    color: #a0a0a0;
  }
}
</style>